import request from '@/utils/request2'

// 商品查询
export function commodityList(data) {
  return request({
    url: `/cloud/edata-commodity/admin/commodity/list`,
    method: 'POST',
    data
  })
}
// 查询商品详情
export function commodityDetail(params) {
  return request({
    url: `/cloud/edata-commodity/admin/commodity/detail`,
    method: 'GET',
    params
  })
}
// 商品保存并上架
export function commoditySaveAndShelve(data) {
  return request({
    url: `/cloud/edata-commodity/admin/commodity/saveAndShelve`,
    method: 'POST',
    data
  })
}
// 商品保存草稿
export function commoditySaveDraft(data) {
  return request({
    url: `/cloud/edata-commodity/admin/commodity/saveDraft`,
    method: 'POST',
    data
  })
}
// 商品上架（批量）
export function commodityShelve(data) {
  return request({
    url: `/cloud/edata-commodity/admin/commodity/shelve`,
    method: 'POST',
    data
  })
}
// 商品各平台发布查询
export function commodityThirdList(params) {
  return request({
    url: `/cloud/edata-commodity/admin/commodity/thirdList`,
    method: 'GET',
    params
  })
}
// 商品下架（批量）
export function commodityUnshelve(data) {
  return request({
    url: `/cloud/edata-commodity/admin/commodity/unshelve`,
    method: 'POST',
    data
  })
}
// 删除商品（批量）
export function commodityDelete(data) {
  return request({
    url: `/cloud/edata-commodity/admin/commodity/delete`,
    method: 'POST',
    data
  })
}
// 商品编辑保存
export function commodityUpdate(data) {
  return request({
    url: `/cloud/edata-commodity/admin/commodity/update`,
    method: 'POST',
    data
  })
}

// 类目属性查询
export function categoryAttributes(params) {
  return request({
    url: `/cloud/edata-commodity/admin/category/attributes`,
    method: 'GET',
    params
  })
}

// 商品类目查询
export function categoryList(params) {
  return request({
    url: `/cloud/edata-commodity/admin/category/list`,
    method: 'GET',
    params
  })
}

// 用户最近使用商品类目查询
export function categoryUserList(params) {
  return request({
    url: `/cloud/edata-commodity/admin/category/userList`,
    method: 'GET',
    params
  })
}
// wx类目属性查询
export function wechatCategoryDetail(params) {
  return request({
    url: `/cloud/edata-commodity/wechat/category/detail`,
    method: 'GET',
    params
  })
}
// wx所有类目列表
export function wechatCategoryList(params) {
  return request({
    url: `/cloud/edata-commodity/wechat/category/list`,
    method: 'GET',
    params
  })
}

// 视频号商品查询
export function wechatProductList(params) {
  return request({
    url: `/cloud/edata-commodity/admin/wechat/product/list`,
    method: 'GET',
    params
  })
}
// 商品上架
export function wechatProductListing(data) {
  return request({
    url: `/cloud/edata-commodity/admin/wechat/product/listing`,
    method: 'PUT',
    data
  })
}

// 商品下架
export function wechatProductDeListing(data) {
  return request({
    url: `/cloud/edata-commodity/admin/wechat/product/deListing`,
    method: 'PUT',
    data
  })
}

// 获取类目下可用的店铺列表
export function wechatStoreAvailable(params) {
  return request({
    url: `/cloud/edata-commodity/admin/wechat/store/available`,
    method: 'GET',
    params
  })
}
// 抖店商品查询
export function doudianProductList(params) {
  return request({
    url: `/cloud/edata-commodity/admin/doudian/product/list`,
    method: 'GET',
    params
  })
}

// 抖店商品类目查询
export function getDoudianCategory(params) {
  return request({
    url: `/cloud/edata-commodity/admin/doudian/category/query`,
    method: 'GET',
    params
  })
}
// 抖店批量商品删除
export function doudianProductDelete(data) {
  return request({
    url: `/cloud/edata-commodity/admin/doudian/product/delete`,
    method: 'POST',
    data
  })
}
// 抖店批量商品上架
export function doudianProductListing(data) {
  return request({
    url: `/cloud/edata-commodity/admin/doudian/product/listing`,
    method: 'POST',
    data
  })
}
// 抖店批量商品下架
export function doudianProductDelisting(data) {
  return request({
    url: `/cloud/edata-commodity/admin/doudian/product/delisting`,
    method: 'POST',
    data
  })
}
// 商品详情 商品编辑 商品拷贝等功能复用
export function doudianProductDetails(params) {
  return request({
    url: `/cloud/edata-commodity/doudian/product/details`,
    method: 'GET',
    params
  })
}

//  抖店商品编辑
export function doudianProductAdd(data) {
  return request({
    url: `/cloud/edata-commodity/admin/doudian/product/add`,
    method: 'POST',
    data
  })
}

//  抖店商品编辑
export function doudianProductEdit(data) {
  return request({
    url: `/cloud/edata-commodity/admin/doudian/product/edit`,
    method: 'POST',
    data
  })
}

// 品牌查询
export function getBrandList(params) {
  return request({
    url: `/cloud/edata-commodity/admin/brand/list`,
    method: 'GET',
    params
  })
}

// 商品分页查询
export function commodityPage(params) {
  return request({
    url: `/cloud/admin/material/goods/commodityPage`,
    method: 'GET',
    params
  })
}
// 获取商品类目属性
export function doudianCategoryProperty(params) {
  return request({
    url: `/cloud/edata-commodity/admin/doudian/category/property`,
    method: 'GET',
    params
  })
}
// 商品类目启用的店铺(抖音)
export function doudianCategoryShop(params) {
  return request({
    url: `/cloud/edata-commodity/admin/doudian/category/shop`,
    method: 'GET',
    params
  })
}
// 获取商品类目资质配置(抖音)
export function doudianQualification(params) {
  return request({
    url: `/cloud/edata-commodity/admin/doudian/category/qualification`,
    method: 'GET',
    params
  })
}
// 商品详情 商品编辑 商品拷贝等功能复用
export function doudianDetails(params) {
  return request({
    url: `/cloud/edata-commodity/admin/doudian/product/details`,
    method: 'GET',
    params
  })
}
// 抖店中台详情
export function doudianZTDetails(params) {
  return request({
    url: `/cloud/edata-commodity/admin/doudian/product/details/with/mid`,
    method: 'GET',
    params
  })
}

// 用户历史类目查询
export function categoryHistory(params) {
  return request({
    url: `/cloud/edata-commodity/admin/doudian/category/history`,
    method: 'GET',
    params
  })
}
